import { type ModalId } from '@heidi/schema/ml-scribe';

/**
 * Seen-state id for the last-week complimentary usage end banner. Cast until
 * the generated schema carries the ml-scribe member; the string is frozen (it
 * keys `seen_modals`).
 */
export const COMPLIMENTARY_TRIAL_END_BANNER_MODAL_ID =
  'T3_CUSTOM_AUDIENCE_HEIDI_2_COMPLIMENTARY_END_BANNER' as ModalId;
